import React, { Component } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { SEE_RESULTS } from "../constants/routesPaths";
import { vetSlidingData } from "../constants/slideVets";
import {
    SLIDE_ACCESSORY,
  SLIDE_ALL,
  SLIDE_FOOD,
  SLIDE_GROOMING,
  SLIDE_HOSPITAL,
  SLIDE_HOSPITAL247,
  SLIDE_VET,
  SLIDE_VET247,
} from "../constants/slideVetsTypes";
import { analytics } from "../firebase.config";

import facebookIcon from "../assets/svgs/facebook_black_icon.svg";
import instagramIcon from "../assets/svgs/instagram_black_icon.svg";
import websiteIcon from "../assets/svgs/website_black_icon.svg";
import phoneIcon from "../assets/svgs/phone_black_icon.svg";
import twitterIcon from "../assets/svgs/twitter_black_icon.svg";
import whatsappIcon from "../assets/svgs/whatsapp_black_icon.svg";
import adoptziLogo from "../assets/svgs/adoptzi_logo.svg";

class Directory extends Component {
  filteredResults;

  constructor(props) {
    super(props);
    this.filteredResults = vetSlidingData;
    this.state = {
      filter: [],
      needleSearch: "",
    };
  }

  componentDidMount() {}

  adVetClick = (vetname) => {
    analytics.logEvent(`Action_DirectoryItemClick`, {
      vetName: vetname,
    });
  };

  checkIfFilterActive = (filter) => {
    if (this.state.filter.indexOf(filter) !== -1) {
      return true;
    } else {
      return false;
    }
  };

  clickFilter = (filter) => {
    let tempFilters = this.state.filter;
    const indexFilter = tempFilters.indexOf(filter);
    if (indexFilter !== -1) {
      tempFilters.splice(indexFilter, 1);
    } else {
      tempFilters.push(filter);
    }

    if (tempFilters.length === 0) {
      this.filteredResults = vetSlidingData;
    } else {
      this.filteredResults = vetSlidingData.filter((item) => {
        let hasFilter = tempFilters.some((value, index) => {
          return item.type.indexOf(value) !== -1;
        });
        return hasFilter;
      });

      this.filteredResults.sort((a,b) => {
        let first = a.recommended,
            second = b.recommended;
            if (first < second) {
                return 1;
            }
            if (first > second) {
                return -1;
            }
            return 0;
      });

      this.filteredResults.sort((a,b) => {
        let first = a.order,
            second = b.order;
            if (first > second && a.recommended && b.recommended) {
                return 1;
            }
            if (first < second && a.recommended && b.recommended) {
                return -1;
            }
            return 0;
      });

    }

    this.setState({
      filter: tempFilters,
    });
  };

  render() {
    return (
      <div key={"directory"}>
        <Navbar whiteVersion={true} customClasses={"navbar--relative"}>
          <Link
            to={SEE_RESULTS}
            className={
              "navbar__links navbar__links--button navbar__links--button-green-bggreen"
            }
          >
            <div className={"navbar__links--button-container"}>
              <span>Regresar a resultados</span>
            </div>
          </Link>
        </Navbar>
        <div className={"directory-container"}>
          <div className={"directory-tag-filters"}>
            <p className={"directory-tag-filters_title"}>Quiero buscar por:</p>
            <div className={"directory-tag-filters_container"}>
              <span
                className={this.checkIfFilterActive(SLIDE_VET) ? "active" : ""}
                onClick={() => {
                  this.clickFilter(SLIDE_VET);
                }}
              >
                Veterinarias
              </span>
              <span
                className={
                  this.checkIfFilterActive(SLIDE_HOSPITAL) ? "active" : ""
                }
                onClick={() => {
                  this.clickFilter(SLIDE_HOSPITAL);
                }}
              >
                Hospitales
              </span>
              <span
                className={
                  this.checkIfFilterActive(SLIDE_GROOMING) ? "active" : ""
                }
                onClick={() => {
                  this.clickFilter(SLIDE_GROOMING);
                }}
              >
                Grooming
              </span>
              <span
                className={
                  this.checkIfFilterActive(SLIDE_FOOD) ? "active" : ""
                }
                onClick={() => {
                  this.clickFilter(SLIDE_FOOD);
                }}
              >
                Comida mascotas
              </span>
              <span
                className={
                  this.checkIfFilterActive(SLIDE_ACCESSORY) ? "active" : ""
                }
                onClick={() => {
                  this.clickFilter(SLIDE_ACCESSORY);
                }}
              >
                Accesorios mascotas
              </span>
              <span
                className={
                  this.checkIfFilterActive(SLIDE_HOSPITAL247) ? "active" : ""
                }
                onClick={() => {
                  this.clickFilter(SLIDE_HOSPITAL247);
                }}
              >
                Hospital 24/7
              </span>
              <span
                className={
                  this.checkIfFilterActive(SLIDE_VET247) ? "active" : ""
                }
                onClick={() => {
                  this.clickFilter(SLIDE_VET247);
                }}
              >
                Veterinaria 24/7
              </span>
            </div>
          </div>
          <div className={"directory-results"}>
          {this.filteredResults.length === 0 && 
              <div>
                  <p className={"directory-results--noresult-title"}>No hay resultados</p>
                  <p className={"directory-results--noresult-desc"}>Aún no tenemos resultados para está búsqueda</p>
                  <a
                    key={'no-results'}
                    onClick={() => {
                      this.adVetClick('noresults');
                    }}
                    href={"https://wa.link/8skz44"}
                    target={"__blank"}
                  >
                    <div className={"directory-filter-item"}>
                      <div className={"directory-filter-item--container"}>
                        <img
                          className={"directory-filter-item--image"}
                          src={adoptziLogo}
                          alt={'No resultados Adoptzi'}
                        />
                        <div className={"directory-filter-item--social"}>
                              <a
                                className={"directory-filter-item--social-item"}
                                target={"__blank"}
                                href={"https://www.facebook.com/adoptzi"}
                              >
                                <img src={facebookIcon} alt={"Facebook icon"} />
                              </a>
                              <a
                                className={"directory-filter-item--social-item"}
                                target={"__blank"}
                                href={"https://www.instagram.com/adoptzi/"}
                              >
                                <img
                                  src={instagramIcon}
                                  alt={"Instagram icon"}
                                />
                              </a>

                              <a
                                className={"directory-filter-item--social-item"}
                                href={"tel://+50242149355"}
                              >
                                <img src={phoneIcon} alt={"Phone icon"} />
                              </a>
                        </div>
                        <div className={"directory-filter-item--information"}>
                          <div className={"directory-filter-item--title"}>
                            {"¿Quiéres estar en este espacio?"}
                          </div>
                          <div className={"directory-filter-item--desc"}>
                            {"Será un gusto poder ponernos en contacto contigo. Puedes dar click sobre este espacio para comunicarte con el equipo de Adoptzi."}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
              </div>
              }
            <div className={"directory-results-container"}>
              {this.filteredResults.length !== 0 && this.filteredResults.map((results) => {
                const imag = results.image? require('../assets/'+ results.image): "";
                return (
                  <a
                    key={results.key}
                    onClick={() => {
                      this.adVetClick(results.name);
                    }}
                    href={results.linkTo}
                    target={"__blank"}
                  >
                    <div className={"directory-filter-item"}>
                      <div className={"directory-filter-item--container"}>
                        <img
                          className={"directory-filter-item--image"}
                          src={imag.default}
                          alt={results.name}
                        />
                        <div className={"directory-filter-item--social"}>
                          {typeof results.social.facebook !== "undefined" &&
                            results.social.facebook !== "" && (
                              <a
                                className={"directory-filter-item--social-item"}
                                target={"__blank"}
                                href={results.social.facebook}
                              >
                                <img src={facebookIcon} alt={"Facebook icon"} />
                              </a>
                            )}
                          {typeof results.social.instagram !== "undefined" &&
                            results.social.instagram !== "" && (
                              <a
                                className={"directory-filter-item--social-item"}
                                target={"__blank"}
                                href={results.social.instagram}
                              >
                                <img
                                  src={instagramIcon}
                                  alt={"Instagram icon"}
                                />
                              </a>
                            )}
                          {typeof results.social.website !== "undefined" &&
                            results.social.website !== "" && (
                              <a
                                className={"directory-filter-item--social-item"}
                                target={"__blank"}
                                href={results.social.website}
                              >
                                <img src={websiteIcon} alt={"Website icon"} />
                              </a>
                            )}
                            {typeof results.social.whatsapp !== "undefined" &&
                            results.social.whatsapp !== "" && (
                              <a
                                className={"directory-filter-item--social-item"}
                                target={"__blank"}
                                href={results.social.whatsapp}
                              >
                                <img src={whatsappIcon} alt={"Whatsapp icon"} />
                              </a>
                            )}
                          {typeof results.social.phone !== "undefined" &&
                            results.social.phone !== "" && (
                              <a
                                className={"directory-filter-item--social-item"}
                                href={results.social.phone}
                              >
                                <img src={phoneIcon} alt={"Phone icon"} />
                              </a>
                            )}
                        </div>
                        <div className={"directory-filter-item--information"}>
                          <div className={"directory-filter-item--title"}>
                            {results.name}
                          </div>
                          <div className={"directory-filter-item--desc"}>
                            {results.description}
                          </div>
                          {typeof results.location !== "undefined" &&
                            results.location !== "" && (
                              <div
                                className={"directory-filter-item--location"}
                              >
                                <p
                                  className={"directory-filter-item--subtitle"}
                                >
                                  Dirección:
                                </p>
                                <p>{results.location}</p>
                              </div>
                            )}
                            <div className={"directory-filter-item--filters"}>
                                {results.type.map((item) => {
                                  return(
                                      <span>{item}</span>
                                  );
                                })}
                            </div>
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Directory;
